// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"688":"603c0dee","987":"3964267f"}[chunkId] + ".chunk.js";
};